import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { TrashSVG } from '../svg/trash.svg';

const TrashIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <TrashSVG/>
    </div>
  );
};

export { TrashIcon };
